export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const SET_USER = 'SET_USER';
export const SET_AUTH_SUCCESS = 'SET_AUTH_SUCCESS';
export const SET_AUTH_ERROR = 'SET_AUTH_ERROR';
export const SET_LOGOUT = 'SET_LOGOUT';
export const SAVE_CANVAS = 'SAVE_CANVAS';
export const CLEAR_CANVAS = 'CLEAR_HISTORY';
export const SET_AUDIO_BUFFER = 'SET_AUDIO_BUFFER';
export const SET_AUDIO_BUFFER_DECODED = 'SET_AUDIO_BUFFER_DECODED';
export const SET_AUDIO_BUFFER_DECODING = 'SET_AUDIO_BUFFER_DECODING';
export const SET_AUDIO_DATA_URL = 'SET_AUDIO_DATA_URL';
export const CLEAR_AUDIO_DATA = 'CLEAR_AUDIO_DATA';
export const SET_JOB_DATA = 'SET_JOB_DATA';
export const SET_USER_DATA = 'SET_USER_DATA';
